<template>
    <div class="sb_doc_files p-3">
        <fileloader
            key="file_loader_mem"
            doc_type="mobile_sb"
            :doc_id="doc.id"
            v-bind:trigger_load="file_trigger"
            v-bind:can_del="true"
            :enable-preview=true
            :files="cur_files"
        >
        </fileloader>
    </div>
</template>

<script>

import fileloader from "../../../../shared/file_loader/fileloader.vue";

export default {
    name: "doc_files",
    components : {
        fileloader
    },
    
    props : {
        doc : {
            type : Object,
        }
    },
    data() {
        return {
            "file_trigger" : "sb_doc_load"
        }
    },
    
    methods: {
        sb_doc_load() {
        
        },
    },
    
    computed: {
        cur_files() {
            if(this.doc.hasOwnProperty("doc_files")) {
                return this.doc.doc_files;
            }
            return [];
        },
    }
}
</script>


<style scoped>

</style>